import React from 'react'
import { Link } from 'react-router-dom'
import { Card, CardActions, CardTitle, CardText } from 'material-ui-legacy/Card'

import DeleteButton from '../UI/DeleteButton'
import EditButton from '../UI/EditButton'
import CloseButton from '../UI/CloseButton'

const AgencyProducerCard = props => {
  // Data can be received either as agencyProducer or itemData.
  const agencyProducer = props.agencyProducer || props.itemData

  return (
    <Card>
      <CardTitle title={agencyProducer.attributes.fullName} />
      <CardText>
        {agencyProducer.attributes.agencyId &&
          agencyProducer.included && (
            <p>
              <strong>Agency:</strong>&nbsp;
              <Link to={`/agencies/${agencyProducer.attributes.agencyId}`}>
                {agencyProducer.included('agency').attributes.name}
              </Link>
            </p>
          )}
        {agencyProducer.attributes.title && (
          <p>
            <strong>Title:</strong> {agencyProducer.attributes.title}
          </p>
        )}
        {agencyProducer.attributes.email && (
          <p>
            <strong>E-mail:</strong>&nbsp;
            <a href={`mailto:${agencyProducer.attributes.email}`}>
              {agencyProducer.attributes.email}
            </a>
          </p>
        )}
        {agencyProducer.attributes.formattedPhones && (
          <p>
            <strong>Phones:</strong> {agencyProducer.attributes.formattedPhones}
          </p>
        )}
        {agencyProducer.attributes.address && (
          <p>
            <strong>Address:</strong> {agencyProducer.attributes.address}
          </p>
        )}
        {agencyProducer.attributes.city && (
          <p>
            <strong>City:</strong> {agencyProducer.attributes.city}
          </p>
        )}
        {agencyProducer.attributes.province && (
          <p>
            <strong>State/Province:</strong>{' '}
            {agencyProducer.attributes.province}
          </p>
        )}
        {agencyProducer.attributes.postalCode && (
          <p>
            <strong>Postal code:</strong> {agencyProducer.attributes.postalCode}
          </p>
        )}
        {agencyProducer.attributes.country && (
          <p>
            <strong>Country:</strong> {agencyProducer.attributes.country}
          </p>
        )}
      </CardText>

      <CardActions>
        {props.editCallback && <EditButton onTouchTap={props.editCallback} />}
        {props.deleteCallback && (
          <DeleteButton
            onTouchTap={props.deleteCallback}
            confirmMessage={
              <p>
                Are you sure you want to delete{' '}
                <strong>{agencyProducer.attributes.name}</strong>? There's no
                undo.
              </p>
            }
          />
        )}
        {props.closeCallback && (
          <CloseButton onTouchTap={props.closeCallback} />
        )}
      </CardActions>
    </Card>
  )
}

export default AgencyProducerCard



// WEBPACK FOOTER //
// ./src/components/AgencyProducers/AgencyProducerCard.jsx